import React from "react";
import { func } from "prop-types";
import * as style from "./styles.module.scss";
import history from "../../history";

const HolidayTryAgain = ({ handleTryAgain }) => {
  return (
    <div
      id="timesheetsError"
      className={`w-100 ${style.timesheets__tryagain} d-flex flex-column justify-content-center align-items-center`}
    >
      <div className="w-100 d-flex flex-column justify-content-center align-items-center">
        <img src="/images/icons/timesheet-error.svg" />
        <h2 className="mt-2 text-center">Holiday loading failed</h2>
        <b className="text-center">
          There has been an error loading your latest holiday information.
        </b>
        <br />
        <b className="text-center">
          Please check again later or contact our Customer Success team at{" "}
          <a href="mailto:customer.success@hrgo.co.uk">
            customer.success@hrgo.co.uk
          </a>
          <br />
          who can investigate further for you.
        </b>
        {/* <b className="text-center">Please click the button below to retry.</b> */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            flexWrap: "wrap",
          }}
        >
          <button
            onClick={() => history.push("/profile")}
            className="btn btn-secondary font-weight-bold mt-2 mr-2"
          >
            Back to My Account
          </button>
          {/* <button
            className="btn btn-primary font-weight-bold mt-2"
            onClick={handleTryAgain}
          >
            Try again
          </button> */}
        </div>
      </div>
    </div>
  );
};

HolidayTryAgain.propTypes = {
  handleTryAgain: func,
};

export default HolidayTryAgain;
